import React from 'react';
import { DropdownMenu } from '../../form';

interface TimeFrameSelectorProps {
  className?: string;
  timeFrames: string[];
  selected: string;
  onChange: (arg: string) => void;
}

const TimeFrameSelector: React.FC<TimeFrameSelectorProps> = ({
  timeFrames,
  selected,
  onChange,
  className = '',
}) => {
  return (
    <div
      className={'w-24 flex justify-center h-full focus-within:border-grey-50'}
    >
      <DropdownMenu
        dropdownClassName={`${className} flex flex-1 items-center h-full  justify-center cursor-pointer`}
        dropdownTooltipClassName="bg-white border-solid border border-grey-30"
        dropdownTooltipXOffset={8}
        dropdownTooltipYOffset={24}
        dropdownArrowClassName="text-black"
        dropdownItems={timeFrames}
        handleClick={onChange}
        showArrow
        arrowPosition="right"
      >
        {selected}
      </DropdownMenu>
    </div>
  );
};

export default TimeFrameSelector;
